.root {
    padding-left: 8px;
    padding-right: 8px;
    background-color: var(--background-color-grey);
}

.content {
    margin-top: 4px;
    margin-bottom: 4px;
}

.row {
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
}

.left {
    display: flex;
    align-items: center;
    min-width: 0;
    overflow: hidden;
}

.label {
    display: flex;
    align-items: center;
    gap: 4px;
    max-width: 250px;
    overflow: hidden;
}

.title {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.4;
}

.meta {
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1.4;
    color: var(--color-text-secondary);
}
